import { RadioGroupItem } from "./parts/item";
import { RadioGroupRoot } from "./radio-group";

export type * from "./types-radio-group";

/** Grupo de opções exclusivas (`RadioGroup.Root/Item`) sobre o `RadioButton` do Prime, com `role="radiogroup"`. */
export const RadioGroup = { Root: RadioGroupRoot, Item: RadioGroupItem };
